// assets/collection-filters.js
import {fetchProductGrid} from './collection-grid';

document.querySelectorAll('.CollectionFilters a').forEach(link => {
  link.addEventListener('click', async (e) => {
    e.preventDefault();
    const url = link.getAttribute('href');
    history.replaceState({}, '', url);

    // Re-fetch the new product grid HTML
    const html = await fetch(url)
      .then(r => r.text())
      .then(text => new DOMParser().parseFromString(text, 'text/html'));

    // Swap in the updated products and pagination
    const newGrid = html.querySelector('.CollectionProductGrid');
    document.querySelector('.CollectionProductGrid').replaceWith(newGrid);
  });
});

// Optional: reset button
document.querySelector('.FiltersReset').addEventListener('click', () => {
  history.replaceState({}, '', window.location.pathname);
  window.location.reload(); // or re-run your fetch logic without params
});
